import React, { useMemo } from 'react';
import { defineMessages } from 'react-intl';
import { styled } from '@linaria/react';
import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage';
const Wrapper = /*#__PURE__*/styled('span')({
  name: "Wrapper",
  class: "w1fij92c",
  propsAsIs: false
});
interface Props {
  includeLocalTaxes: boolean;
  includeTaxes: boolean;
  showTotalPrices: boolean;
}
export const messages = defineMessages({
  total: {
    id: 'priceDisplay.total',
    defaultMessage: 'Total price incl tax & fees'
  },
  nightlyWithTaxes: {
    id: 'priceDisplay.nightly',
    defaultMessage: 'Nightly price incl tax & fees'
  },
  nightly: {
    id: 'nightlyPrice',
    defaultMessage: 'Nightly price'
  }
});
export const Taxation: React.FC<Props> = ({
  includeLocalTaxes,
  includeTaxes,
  showTotalPrices
}) => {
  const message = useMemo(() => {
    if (showTotalPrices) return messages.total;
    if (includeTaxes || includeLocalTaxes) return messages.nightlyWithTaxes;
    return messages.nightly;
  }, [includeLocalTaxes, includeTaxes, showTotalPrices]);
  return <Wrapper>
      <FormattedMessageWrapper {...message} />
    </Wrapper>;
};

require("./Taxation.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./Taxation.tsx");